import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Trustedecommerceweb() {
  return (
    <section className="trusted_ecommerce_web p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Your Trusted eCommerce <span>Web Development Company</span>
            </h2>
            <p>
              TekRevol, a leading e-commerce web development company,
              specializes in building dynamic and innovative online retail
              solutions. From user-friendly online stores to comprehensive
              management systems, we deliver high-performing, well-executed
              projects tailored to drive e-commerce success.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={11} xxl={10} className="m-auto">
            <Row className="mt-3 mt-md-4">
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">01</div>
                  <div className="ecomm_box_content">
                    <h5>Enhanced User Experience</h5>
                    <p>
                      Implement intuitive designs and seamless navigation for a
                      superior shopping experience. Increase customer
                      satisfaction and retention with user-friendly interfaces.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mb-4">
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">02</div>
                  <div className="ecomm_box_content">
                    <h5>Advanced Data Analytics</h5>
                    <p>
                      Integrate powerful analytics tools to track user behavior
                      and sales trends. Make data-driven decisions to optimize
                      your e-commerce strategy and performance.
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                xs={12}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className="mb-md-0 mb-4"
              >
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">03</div>
                  <div className="ecomm_box_content">
                    <h5>Omnichannel Integration</h5>
                    <p>
                      Synchronize your online store with various sales channels
                      for a unified experience. Manage inventory, orders, and
                      customer data effortlessly across platforms.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                <div className="trusted_ecomm_box">
                  <div className="ecomm_title">04</div>
                  <div className="ecomm_box_content">
                    <h5>Automated Marketing Tools</h5>
                    <p>
                      Deploy automated marketing solutions for personalized
                      customer outreach. Boost engagement, drive conversions,
                      and increase ROI with targeted campaigns.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Trustedecommerceweb;
